export default "__VITE_ASSET__BZr3kC_U__"